export enum TabType {
    DESCRIPTION = 'description',
    SPECIFICATION = 'specification',
    REVIEWS = 'reviews',
    WARRANTY = 'guaranty',
    TECHNICAL_DOCUMENTATION = 'technical_documentation',
    BUNDLE_INCLUDES = 'bundle-includes'
}

export default function Navigation({selected, setSelected}: {
    selected: TabType,
    setSelected: (selected: TabType) => void
}) {

    const tabNames = {
        [TabType.DESCRIPTION]: 'Описание',
        [TabType.SPECIFICATION]: 'Характеристики',
        [TabType.REVIEWS]: 'Отзывы',
        [TabType.WARRANTY]: 'Гарантия',
        [TabType.TECHNICAL_DOCUMENTATION]: 'Тех. документация',
        [TabType.BUNDLE_INCLUDES]: 'Комплектации'
    }

    return (<ul className="nav-tabs product__nav-tabs" id="prodTab" role="tablist">
        {[TabType.DESCRIPTION, TabType.SPECIFICATION,  TabType.WARRANTY, TabType.TECHNICAL_DOCUMENTATION, TabType.BUNDLE_INCLUDES].map((tab) => (
        <li className="nav-item"  key={tab}>
            <a className={selected === tab ? 'active' : ''}
               href={`/`}
               onClick={(event) => {
                   event.preventDefault()
                   setSelected(tab)
               }}>
                {tabNames[tab]}
            </a>
        </li>
        ))}
    </ul>)
}